import { BugReportCommentType } from 'features/call/call-comments/enums';
import { BugReportReason } from 'features/call/vrs-call-comments/enums';

export const BugReportReasonOption: Record<string, BugReportCommentType[]> = {
  [BugReportReason.VIDEO]: [
    BugReportCommentType.BRVIDPIX,
    BugReportCommentType.BRVIDFRZ,
    BugReportCommentType.BRVIDBKI,
    BugReportCommentType.BRVIDBKC,
  ],
  [BugReportReason.AUDIO]: [
    BugReportCommentType.BRAUDCON,
    BugReportCommentType.BRAUDDST,
    BugReportCommentType.BRAUDECO,
  ],
  [BugReportReason.CALLER_TEXT]: [
    BugReportCommentType.BRTXTNVC,
    BugReportCommentType.BRTXTNVI,
  ],
  [BugReportReason.EMERGENCY]: [
    BugReportCommentType.BREMAGCY,
    BugReportCommentType.BREMNLOC,
  ],
  [BugReportReason.DIALPAD]: [
    BugReportCommentType.BRDPNSND,
    BugReportCommentType.BRDPNSEE,
  ],
  [BugReportReason.TEAMING]: [
    BugReportCommentType.BRTMCREQ,
    BugReportCommentType.BRTMFAIL,
    BugReportCommentType.BRTMWLOC,
  ],
  [BugReportReason.HANDOFF]: [
    BugReportCommentType.BRHOIWRM,
    BugReportCommentType.BRHOIRTQ,
  ],
};
